import * as React from 'react';
import { V2C, fontBody } from './tokens';

interface V2SaveErrorProps {
  onRetry: () => void;
  onDismiss: () => void;
}

export default function V2SaveError({ onRetry, onDismiss }: V2SaveErrorProps) {
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 200,
      background: V2C.err, color: '#fff',
      padding: '12px 16px',
      display: 'flex', alignItems: 'center', gap: 10,
      fontFamily: fontBody, fontSize: 13,
      animation: 'v2bannerIn 0.3s cubic-bezier(0.16,1,0.3,1)',
      boxShadow: '0 -2px 16px rgba(0,0,0,0.12)',
    }}>
      <span style={{ flex: 1, minWidth: 0, lineHeight: 1.4 }}>
        Couldn't save your profile. Check your connection and try again.
      </span>
      <button
        onClick={onRetry}
        style={{
          background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
          fontFamily: fontBody, fontWeight: 700, fontSize: 12,
          padding: '5px 10px', borderRadius: 8, cursor: 'pointer', flexShrink: 0,
        }}
      >
        Retry
      </button>
      <button
        onClick={onDismiss}
        aria-label="Dismiss error"
        style={{
          background: 'transparent', border: 'none', color: '#fff',
          fontSize: 18, lineHeight: 1, padding: '0 2px', cursor: 'pointer', flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
